import styled from "styled-components";

export const StyledAppHeader = styled.div`
  padding: 12px 16px 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0%;
  left: 0%;
  height: ${({ theme }) => `${theme.header.height}px`};
  background: ${({ theme }) => theme.palette.background.default};
  width: 100%;
  z-index: 1000;
  box-shadow: 3px 0px 0px 1px rgba(0, 0, 0, 0.1),
    2px 0px 0px 1px rgba(0, 0, 0, 0.06);
  svg {
    cursor: pointer;
  }
  .menu-icon {
    stroke: ${({ theme }) => theme.palette.text.primary};
  }
`;
